module.exports = __webpack_public_path__ + "static/media/wheelHandle2.13a6e46b.png";